<!-- <script type="text/javascript" src="https://app.mailerlite.com/data/webforms/28337/c0a2z5.js?v10"></script> -->
<form style="margin:4px; padding: 20px; border: 2px solid #888; border-radius: 6px" class="ml-block-form"
    action="https://landing.mailerlite.com/webforms/submit/c0a2z5" data-id="28337" data-code="c0a2z5" method="POST"
    target="_blank">
    <div class="subscribe-form">
        <div class="form-section mb10">
            <p style="text-align: center; font-size: 14px; line-height: 21px;"><span
                    style="font-size: 20px;"><strong><span style="color: #000000;">&nbsp;عضویت درخبرنامه تحلیلی روزانه
                            کارگزاری آبان</span></strong></span></p>
            <p style="text-align: center;"><span style="color: #2980b9;">&nbsp;</span></p>
            <p style="text-align: center; font-size: 14px; line-height: 21px;"><span style="color: #c0392b;">بیانیه رفع
                    مسئولیت</span></p>
            <p style="text-align: center; font-size: 14px; line-height: 21px;"><span
                    style="color: #c0392b;">----------------------------</span></p>
            <p style="text-align: center; font-size: 14px; line-height: 21px;"><span style="color: #c0392b;">این گزارش
                    تنها بیانگر نظرات کارشناسان و تحلیلگران شرکت کارگزاری آبان است و به هیچ عنوان به معنی توصیه ای جهت
                    خرید یا فروش سهام نمیباشد و شرکت کارگزاری آبان هیچگونه مسئولیتی در قبال ضرر و زیان ناشی از انجام هر
                    گونه معامله ای با اتکا بر این گزارش را بر عهد نخواهد گرفت</span></p>
            <p style="text-align: center;">&nbsp;</p>
            <p style="text-align: center; font-size: 14px; line-height: 21px;">شما با تکمیل این فرم اذعان می دارید
                بیانیه رفع مسئولیت را مطالعه و از مفاد آن مطلع می باشید و در خواست می نمایید گزارش تحلیلی روزانه این
                شرکت را از طریق پست الکترونیک خود دریافت نمایید</p>
        </div>
        <div class="form-section">
            <div class="form-group ml-field-email ml-validate-required ml-validate-email">
                <input ngModel type="email" name="email" class="form-control" placeholder="پست الكترونيك*" value=""
                    autocomplete="email" x-autocompletetype="email" spellcheck="false" autocapitalize="off"
                    autocorrect="off" aria-invalid="false">
            </div>
            <div class="form-group ml-field-name ml-validate-required">
                <input ngModel type="text" name="name" class="form-control" placeholder="نام*" value=""
                    autocomplete="name" x-autocompletetype="name" spellcheck="false" autocapitalize="off"
                    autocorrect="off" aria-invalid="false">
            </div>
            <div class="form-group ml-field-last_name ml-validate-required">
                <input ngModel type="text" name="last_name" class="form-control" placeholder="نام خانوادگي*" value=""
                    spellcheck="false" autocapitalize="off" autocorrect="off" aria-invalid="false">
            </div>
            <div class="form-group ml-field-phone ml-validate-required">
                <input ngModel type="text" name="phone" class="form-control" placeholder="تلفن*" value=""
                    spellcheck="false" autocapitalize="off" autocorrect="off" aria-invalid="false">
            </div>
        </div>


        <button type="submit" style="width: 100%; padding: 6px;" class="primary gradient-on">
            ثبت عضويت
        </button>
        <button disabled="disabled" style="display: none;" type="button" class="loading gradient-on">
            <img src="https://static.mailerlite.com/images/rolling@2x.gif" width="20" height="20"
                style="width: 20px; height: 20px;">
        </button>
    </div>
</form>